import React, { useContext } from 'react';
import styled from 'styled-components';

import CategoryBox from 'components/item/CategoryBox';

import IsOwner from 'components/shared/IsOwner';
import ErrorBox from 'components/shared/ErrorBox';
import MainHeader from 'components/shared/MainHeader';

import PrimaryButton from 'components/shared/buttons/PrimaryButton';

import { ItemContext } from 'components/shared/context/ItemContextProvider';
import { ModalContext } from 'components/shared/context/ModalContextProvider';
import { UserContext } from 'components/shared/context/UserContextProvider';

interface ItemBoxHeaderSectionProps {
  isOwner: boolean;
}

const ItemBoxHeaderSection = styled.div<ItemBoxHeaderSectionProps>`
  display: grid;
  grid-template-columns: ${(props) => (props.isOwner ? '1fr 140px' : '1fr')};
  gap: 20px;

  align-items: flex-end;
`;

const ItemBox: React.FC = () => {
  const { item } = useContext(ItemContext);
  const { userState } = useContext(UserContext);
  const { openAddCategoryModal } = useContext(ModalContext);

  return item ? (
    <>
      <ItemBoxHeaderSection isOwner={Boolean(userState.isOwner)}>
        <MainHeader>{item.name}</MainHeader>
        <IsOwner>
          <PrimaryButton
            buttonText="Add category"
            disabled={false}
            loading={false}
            buttonWidth="140px"
            onClick={() => {
              openAddCategoryModal?.();
            }}
          />
        </IsOwner>
      </ItemBoxHeaderSection>
      {item.categories?.length ? (
        item.categories.map((category, key) => {
          return <CategoryBox category={category} key={key} />;
        })
      ) : (
        <ErrorBox errorMessage="No categories yet" />
      )}
    </>
  ) : (
    <ErrorBox errorMessage="Item not found" />
  );
};

export default ItemBox;
